import React from 'react'
import Banner from '../components/Banner'
import {connect} from 'react-redux'
import {getIsGeoEU, acceptCookies, refuseCookies} from 'ducks/app'

const scriptsWithCookies = {
  gtm() {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-PDQG75');
  }
}

const mapStateToProps = state => ({
  acceptCookies: state.app.acceptCookies,
})

const mapDispatchToProps = (dispatch, props) => ({
  getIsGeoEU: () => dispatch(getIsGeoEU()),
  onAcceptCookies: () => dispatch(acceptCookies()),
  onRefuseCookies: () => dispatch(refuseCookies()),
})

@connect(mapStateToProps, mapDispatchToProps)
class BannerContainer extends React.Component {
  state = {
    isEU: false,
    show: true,
  }

  async componentDidMount() {
    const {acceptCookies, getIsGeoEU} = this.props

    try {
      const isEU = await getIsGeoEU()

      this.setState({isEU})

      if (acceptCookies || ! isEU) {
        this.initScriptsWithCookies()
      }
    } catch (e) {
      console.error(e)
    }
  }

  render() {
    const {acceptCookies} = this.props
    const {isEU, show} = this.state

    return (
      <Banner
        showRefuseButton={isEU}
        show={! acceptCookies && show}
        onAcceptCookies={this.accept}
        onRefuseCookies={this.refuse}
      />
    )
  }

  accept = () => {
    if (this.state.isEU) {
      this.initScriptsWithCookies()
    }

    this.hide()
    this.props.onAcceptCookies()
  }

  refuse = () => {
    this.hide()
    this.props.onRefuseCookies()
  }

  hide = () => {
    this.setState({show: false})
  }

  initScriptsWithCookies = () => {
    Object.keys(scriptsWithCookies).forEach(scriptName => {
      scriptsWithCookies[scriptName]()
    })
  }
}

export default BannerContainer



// WEBPACK FOOTER //
// ./src/components/CustomComponents/CookieConsent/containers/Banner.js